import { Component, Input } from '@angular/core'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { CommonModule } from '@angular/common'

@Component({
  standalone: true,
  selector: 'lin-password-strength',
  imports: [CommonModule, MatProgressBarModule],
  template: `<mat-progress-bar [value]="strength" [color]="color"></mat-progress-bar>`,
})
export class PasswordStrengthComponent {
  @Input() password = ''

  get strength(): number {
    let score = 0
    if (this.password.length >= 8) score += 25
    if (/[A-Z]/.test(this.password)) score += 25
    if (/[0-9]/.test(this.password)) score += 25
    if (/[^A-Za-z0-9]/.test(this.password)) score += 25
    return score
  }

  get color(): 'warn' | 'accent' | 'primary' {
    if (this.strength < 50) return 'warn'
    if (this.strength < 75) return 'accent'
    return 'primary'
  }
}
